module.exports = new __parcel__URL__("medium.825ac8e1.svg").toString();